import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { Item as dxListItem, ItemClickEvent } from 'devextreme/ui/list';

import { NextPimField } from 'app/Model/Catalog/NextPimField';
import { TemplateService } from 'app/Services/template.service';
import { TemplateItem } from 'app/Model/Catalog/TemplateItem';
import { comparePimFields, fillLastKey, isNextPimField, parsePimField } from 'app/Services/templateItemHelpers';
import { TemplateItemTemplate } from '../../Model/Catalog/TemplateItemTemplate';

@Component({
  selector: 'np-advanced-template-defaultfield',
  templateUrl: './advanced-template-defaultfield.component.html',
})
export class AdvancedTemplateDefaultFieldComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();

  @Input() templateItem: TemplateItem;
  @Input() customerId: string;
  @Input() fieldList: TemplateItemTemplate[] = [];
  @Output() onUpdate = new EventEmitter<void>();

  ///field list wird mi9t .sellsiteFeldern gefüllt

  get pimField() {
    if (!this.templateItem.pimFields || this.templateItem.pimFields.length === 0) {
      this.templateItem.pimFields = [new NextPimField()];
    }
    return this.templateItem.pimFields[0];
  }

  constructor(private templateService: TemplateService) {}

  ngOnInit() {
    this.pimField.systemKey = '-1';
    this.pimField.elementKey = '-1';
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getFieldDisplayExpr(item: TemplateItemTemplate) {
    return item?.text === item?.field ? item?.field ?? '' : `${item.text} (${item.field})`;
  }

  onFieldItemClick(event: ItemClickEvent<TemplateItemTemplate>) {
    this.pimField.field = event.itemData.field;
    this.update();
  }

  triggerKeyGeneration() {
    this.templateItem.key = '';
    this.update();
  }

  private update() {
    const { field, systemKey, elementKey } = this.pimField;
    const parsedKey = parsePimField(this.templateItem.key);
    if (parsedKey !== null && (comparePimFields(parsedKey, this.pimField) || !isNextPimField(parsedKey.field))) {
      this.onUpdate.emit();
      return;
    }
    this.templateService.getHeadline(field, elementKey, systemKey, this.customerId).subscribe((headline) => {
      fillLastKey(this.templateItem, headline.value);
      this.onUpdate.emit();
    });
  }
}
